import { paths } from "../../../config/paths";
import { UniversalProfilerPage } from "../../../features/profiler/components/UniversalProfilerPage";
import { useNavigate } from "react-router-dom";

export const FragranceProfilerProfiler = () => {
  const navigate = useNavigate();
  const handleBack = () => {
    navigate(paths.app.path);
  };

  return (
    <UniversalProfilerPage
      profiler="fragrance-profiler"
      onBack={handleBack}
    />
  );
}; 